import { render, staticRenderFns } from "./addMer.vue?vue&type=template&id=0b7968ce"
import script from "./addMer.vue?vue&type=script&lang=js"
export * from "./addMer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports